import { usePage } from "@hooks/usePage";
import { useEffect } from "react";
import RegistersFilter from "../components/RegistersFilter";
import { useRegistersFilters } from "@hooks/useRegistersFilters";
import TableView from "../components/TableView";
import MapView from "../components/MapView";
import ModalEditRegister from "../components/modal/ModalEditRegister";
import ModalNewRegister from "../components/modal/ModalNewRegister";

function RegistersScreen() {
  const { viewMode } = usePage();

  const {
    filters,
    appliedFilters,
    handleChange: handleFilterChange,
    apply: applyFilters,
    reset: resetFilters,
  } = useRegistersFilters();

  useEffect(() => {
    resetFilters();
  }, [viewMode, resetFilters]);

  return (
    <div className="space-y-6">
      <RegistersFilter
        filters={filters}
        onChange={handleFilterChange}
        onApply={applyFilters}
      />

      {viewMode === "map" ? (
        <MapView appliedFilters={appliedFilters} />
      ) : (
        <TableView appliedFilters={appliedFilters} />
      )}

      <ModalNewRegister />
      <ModalEditRegister />
    </div>
  );
}

export default RegistersScreen;
